<template>
    <order-details-itinerary-info v-if="order && !authStore.person" />
</template>

<script setup lang="ts">
    import {useAsyncData} from 'nuxt/app'
    import OrderDetailsItineraryInfo from '~/components/account/OrderDetailsItineraryInfo.vue'

    const $route = useRoute()
    const router = useRouter()
    const {id, name} = $route.params
    const app = useNuxtApp()
    const order = ref<any>(null)
    const isTripAssistantKeyExist = ref<boolean>(false)
    provide('isTripAssistantKeyExist', isTripAssistantKeyExist)

    watch(
        () => authStore.person,
        () => {
            if (authStore.person) {
                router.push({name: 'order-details', params: {id: id}})
                isTripAssistantKeyExist.value = false
            }
        },
        {deep: true, immediate: true}
    )

    const {data, error} = await useAsyncData(
        `order-info-${id}-${name}-${$route.query?.key}`,
        async () =>
            await app.$api.tripAssistant.get({
                orderId: id,
                travelerName: decodeURIComponent(name),
                orderType: 'TO',
                ...($route.query?.key && {key: $route.query?.key}),
            })
    )

    if (data.value?.ordersCount === 0 || error.value) {
        redirectOnNotFoundPage()
    } else if (data.value?.orders?.length > 0) {
        order.value = data.value.orders[0]
        isTripAssistantKeyExist.value = data.value.isTripAssistantKeyExist || false
        runtimeStore.SET_ORDER_DETAILS(data.value.orders[0])
    }

    function redirectOnNotFoundPage() {
        if (history) {
            history.pushState({name: 'home'}, '', '/')
        }
        const event = new PopStateEvent('popstate')
        window.dispatchEvent(event)

        router.push('/error')
    }
</script>
